<template>
  <div>
    <portal v-if="editMode && !(fundingSummation - expensesSummation === 0)" to="project-action-bar">
      <div class="text-danger pt-1">* ต้องจัดสรรรายละเอียดค่าใช้จ่ายให้ตรงกับงบประมาณที่ตั้งไว้ จึงจะสามารถใช้บันทึกข้อมูลได้</div>
    </portal>

    <template v-if="editMode">
      <table class="table table-striped table-bordered table-sm w-auto mb-0">
        <tbody>
          <tr>
            <th class="text-right" width="120">งบประมาณ</th>
            <td class="text-right" width="180">{{ fundingSummation | numeral('0,0.00') }} บาท</td>
          </tr>
          <tr>
            <th class="text-right">จัดสรรแล้ว</th>
            <td class="text-right">{{ expensesSummation | numeral('0,0.00') }} บาท</td>
          </tr>
          <tr>
            <th class="text-right">คงเหลือ</th>
            <td class="text-right">{{ fundingSummation - expensesSummation | numeral('0,0.00') }} บาท</td>
          </tr>
        </tbody>
      </table>
      <div class="mb-3">
        <small>* ต้องจัดสรรรายละเอียดค่าใช้จ่ายให้ตรงกับงบประมาณที่ตั้งไว้ จึงจะสามารถใช้บันทึกข้อมูลได้</small><br>
        <small>* สำหรับเศษสตางค์ ให้ใช้ทศนิยมไม่เกิน 2 ตำแหน่ง</small>
      </div>
    </template>

    <template v-if="editMode">
      <div>
        <b-alert variant="danger" show>
          <h4 class="alert-heading">โปรดทราบ</h4>
          <p>
            เนื่องจากระบบฯคำนวณยอดรวมให้โดยอัตโนมัติ หากรายการใดที่ยอดรวมคิดเป็นราคาเหมา หรือกรณีอื่นใด <strong><u>ที่เมื่อหารจำนวนต่อชิ้นแล้วได้เศษสตางค์ที่มีทศนิยมมากกว่า 2 ตำแหน่ง หรือเป็นทศนิยมซ้ำ</u></strong> ให้ระบุจำนวนชิ้นเป็น "1" และหน่วยนับเป็น "งาน" (หรือหน่วยนับอื่นตามความเหมาะสม) และจำนวนเงินต่อชิ้นเป็นราคาเหมา เช่น
            <ul>
              <li>จ้างร้านค้าผลิตเสื้อจำนวน 30 ตัว ร้านค้าคิดเป็นราคาเหมา 4,000.00 บาท</li>
              <li>เมื่อหารแล้ว ได้ราคาต่อ 1 ตัวที่ 133.3333... บาท</li>
              <li>ให้ระบุรายการใช้จ่ายดังนี้</li>
              <ol>
                <li>เลือดหมวดค่าใช้จ่ายตามต้องการ</li>
                <li>ในช่อง "ระบุ" กรอก <b-badge>จ้างผลิตเสื้อจำนวน 30 ตัว</b-badge> จากนั้นคลิกปุ่ม "เพิ่มค่าใช้จ่าย"</li>
                <li>กรอกจำนวน <b-badge>1</b-badge> และ หน่วยนับ <b-badge>งาน</b-badge></li>
                <li>กรอกจำนวนเงินต่อหน่วย <b-badge>4000</b-badge> และ หน่วยนับ <b-badge>บาท/งาน</b-badge></li>
              </ol>
            </ul>
          </p>
        </b-alert>
      </div>
    </template>

    <table class="table table-striped table-bordered table-sm">
      <thead>
        <tr>
          <th class="text-center align-middle" width="40">#</th>
          <th class="text-center align-middle">หมวดเงิน/รายการ</th>
          <th class="text-center align-middle" width="100">จำนวน</th>
          <th class="text-center align-middle" width="100">หน่วยนับ</th>
          <th class="text-center align-middle" width="100">ระยะเวลา</th>
          <th class="text-center align-middle" width="100">หน่วยนับ</th>
          <th class="text-center align-middle" width="100">จำนวนเงินต่อหน่วย</th>
          <th class="text-center align-middle" width="100">จำนวน</th>
          <th class="text-center align-middle" width="100">หน่วยนับ</th>
          <th class="text-center align-middle" width="100">รวม (บาท)</th>
          <th v-if="editMode" class="text-center align-middle" width="120">ลบ</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(expenseGroup, groupIndex) in expenseGroups">
          <tr :key="groupIndex">
            <td v-if="editMode" colspan="11"><strong>{{ expenseGroup.title }}</strong></td>
            <td v-else colspan="10"><strong>{{ expenseGroup.title }}</strong></td>
          </tr>
          <tr v-for="(expense, index) in value.expenses[expenseGroup.key]" :key="expenseGroup.key + '_' + index">
            <td class="text-center">{{ index + 1 }}</td>
            <td class="align-middle">
              {{ expense.title }}<br>
              <small>{{ expense.description }}</small>
            </td>
            <td class="text-center">
              <b-input v-if="editMode" v-model.number="expense.qty" :disabled="!forms[expenseGroup.key].options.filter(option => option.value === expense.title)[0].fillable[0]" type="number" min="0" class="text-center" size="sm" />
              <span v-else>
                <span v-if="expense.qty">{{ expense.qty | numeral('0,0') }}</span>
              </span>
            </td>
            <td class="text-center">
              <b-input v-if="editMode" v-model.trim="expense.qtySuffix" :disabled="!forms[expenseGroup.key].options.filter(option => option.value === expense.title)[0].fillable[1]" class="text-center" size="sm" />
              <span v-else>{{ expense.qtySuffix }}</span>
            </td>
            <td class="text-center">
              <b-input v-if="editMode" v-model.number="expense.times" :disabled="!forms[expenseGroup.key].options.filter(option => option.value === expense.title)[0].fillable[2]" type="number" min="0" class="text-center" size="sm" />
              <span v-else>
                <span v-if="expense.times">{{ expense.times | numeral('0,0') }}</span>
              </span>
            </td>
            <td class="text-center">
              <b-input v-if="editMode" v-model.trim="expense.timesSuffix" :disabled="!forms[expenseGroup.key].options.filter(option => option.value === expense.title)[0].fillable[3]" class="text-center" size="sm" />
              <span v-else>{{ expense.timesSuffix }}</span>
            </td>
            <td class="text-center">
              <b-input v-if="editMode" v-model.number="expense.amountEach" :disabled="!forms[expenseGroup.key].options.filter(option => option.value === expense.title)[0].fillable[4]" type="number" min="0" class="text-center" size="sm" />
              <span v-else>
                <span v-if="expense.amountEach">{{ expense.amountEach | numeral('0,0.00') }}</span>
              </span>
            </td>
            <td class="text-center">
              <b-input v-if="editMode" v-model.number="expense.amountQty" :disabled="!forms[expenseGroup.key].options.filter(option => option.value === expense.title)[0].fillable[5]" type="number" min="0" class="text-center" size="sm" />
              <span v-else>
                <span v-if="expense.amountQty">{{ expense.amountQty | numeral('0,0') }}</span>
              </span>
            </td>
            <td class="text-center">
              <b-input v-if="editMode" v-model.trim="expense.amountQtySuffix" :disabled="!forms[expenseGroup.key].options.filter(option => option.value === expense.title)[0].fillable[6]" class="text-center" size="sm" />
              <span v-else>{{ expense.amountQtySuffix }}</span>
            </td>
            <td class="text-center">{{ expense.amountEach * (expense.amountQty > 0 ? expense.amountQty : 1) * (expense.times > 0 ? expense.times : 1) * (expense.qty > 0 ? expense.qty : 1) | numeral('0,0.00') }}</td>
            <td v-if="editMode" class="text-center"><b-button variant="outline-danger" size="sm" @click="deleteExpense(expenseGroup.key, index)">ลบ</b-button></td>
          </tr>
          <tr v-if="editMode" :key="expenseGroup.key + '_button_' + groupIndex">
            <td colspan="11">
              <div class="form-inline">
                <b-select v-model="forms[expenseGroup.key].selected" :options="forms[expenseGroup.key].options" size="sm" class="mr-2" @change="forms[expenseGroup.key].description = ''">
                  <template slot="first">
                    <option :value="null" disabled>เลือกประเภทค่าใช้จ่าย</option>
                  </template>
                </b-select>
                <template v-if="forms[expenseGroup.key].selected">
                  <b-input
                    v-if="forms[expenseGroup.key].options.filter(option => option.value === forms[expenseGroup.key].selected)[0].hasDescription"
                    v-model="forms[expenseGroup.key].description"
                    type="text"
                    size="sm"
                    placeholder="ระบุ..."
                    class="mr-2"
                  />
                </template>
                <b-button
                  size="sm"
                  variant="primary"
                  @click="addExpense(expenseGroup.key, forms[expenseGroup.key].selected, forms[expenseGroup.key].description, forms[expenseGroup.key].options.filter(option => option.value === forms[expenseGroup.key].selected)[0].suffixes)"
                >
                  <font-awesome-icon icon="plus-circle" />เพิ่มค่าใช้จ่าย
                </b-button>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
      <tfoot>
        <tr>
          <td v-if="editMode" colspan="10" class="text-right"><strong>รวมเป็นเงิน</strong></td>
          <td v-else colspan="9" class="text-right"><strong>รวมเป็นเงิน</strong></td>
          <td class="text-center">{{ expensesSummation | numeral('0,0.00') }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import Decimal from 'decimal.js-light'
import _ from 'lodash'

export default {
  props: {
    value: { type: Object, required: true },
    editMode: { type: Boolean, required: false, default: true }
  },
  data () {
    return {
      expenseGroups: [
        { key: 'general', title: 'หมวดค่าใช้สอย' },
        { key: 'people', title: 'หมวดค่าตอบแทน' },
        { key: 'materials', title: 'หมวดค่าวัสดุ' },
        { key: 'utilities', title: 'ค่าสาธารณูปโภค' }
      ],
      forms: {
        general: {
          selected: null,
          description: '',
          options: [
            { text: 'ค่าอาหารเช้า', value: 'ค่าอาหารเช้า', hasDescription: false, suffixes: ['คน', 'วัน', 'บาท/มื้อ'], fillable: [true, true, true, true, true, false, true] },
            { text: 'ค่าอาหารกลางวัน', value: 'ค่าอาหารกลางวัน', hasDescription: false, suffixes: ['คน', 'วัน', 'บาท/มื้อ'], fillable: [true, true, true, true, true, false, true] },
            { text: 'ค่าอาหารเย็น', value: 'ค่าอาหารเย็น', hasDescription: false, suffixes: ['คน', 'วัน', 'บาท/มื้อ'], fillable: [true, true, true, true, true, false, true] },
            { text: 'ค่าอาหารว่างและเครื่องดื่ม (ไม่เกิน 30 บาท/คน/มื้อ)', value: 'ค่าอาหารว่างและเครื่องดื่ม', hasDescription: false, suffixes: ['คน', 'วัน', 'บาท/มื้อ'], fillable: [true, true, true, true, true, true, true] },
            { text: 'ค่าที่พัก', value: 'ค่าที่พัก', hasDescription: false, suffixes: ['ห้อง', 'คืน', 'ห้อง/คืน'], fillable: [true, true, true, true, true, false, true] },
            { text: 'ค่าจ้างเหมาบริการ (ระบุ)', value: 'ค่าจ้างเหมาบริการ', hasDescription: true, suffixes: ['งาน', '', 'บาท/งาน'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าซ่อมแซมและบำรุงรักษาครุภัณฑ์ (ระบุ)', value: 'ค่าซ่อมแซมและบำรุงรักษาครุภัณฑ์', hasDescription: true, suffixes: ['งาน', '', 'บาท/งาน'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าสมาชิกและแข่งขัน (ระบุ)', value: 'ค่าสมาชิกและแข่งขัน', hasDescription: true, suffixes: ['คน', '', 'บาท/คน'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าเดินทาง', value: 'ค่าเดินทาง', hasDescription: false, suffixes: ['คน', '', 'บาท/คน'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าธรรมเนียม (ระบุ)', value: 'ค่าธรรมเนียม', hasDescription: true, suffixes: ['คน', '', 'บาท/คน'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าเช่าพื้นที่ (ระบุ)', value: 'ค่าเช่าพื้นที่', hasDescription: true, suffixes: ['ชั่วโมง/วัน', 'วัน', 'บาท/ชั่วโมง'], fillable: [true, true, true, true, true, false, true] }
          ]
        },
        people: {
          selected: null,
          description: '',
          options: [
            { text: 'ค่าตอบแทน (ระบุ)', value: 'ค่าตอบแทน', hasDescription: true, suffixes: ['คน', 'วัน', 'บาท/ชม.'], fillable: [true, true, true, true, true, false, true] },
            { text: 'ค่าเบี้ยเลี้ยง (ระบุ)', value: 'ค่าเบี้ยเลี้ยง', hasDescription: true, suffixes: ['คน', 'วัน', 'บาท/วัน'], fillable: [true, true, true, true, true, false, true] }
          ]
        },
        materials: {
          selected: null,
          description: '',
          options: [
            { text: 'ค่าวัสดุสำนักงานใช้ไป (รวมน้ำดื่ม) (ระบุ)', value: 'ค่าวัสดุสำนักงาน', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุโฆษณาและเผยแพร่ใช้ไป (ระบุ)', value: 'ค่าวัสดุโฆษณาและเผยแพร่ใช้ไป', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุการศึกษาใช้ไป (ระบุ)', value: 'ค่าวัสดุการศึกษาใช้ไป', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุน้ำมันเชื้อเพลิงและหล่อลื่น (ระบุ)', value: 'ค่าวัสดุน้ำมันเชื้อเพลิงและหล่อลื่น', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุงานบ้านงานครัวใช้ไป (ระบุ)', value: 'ค่าวัสดุงานบ้านงานครัวใช้ไป', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุก่อสร้างและประปา (ระบุ)', value: 'ค่าวัสดุก่อสร้างและประปา', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุเวชภัณฑ์และการแพทย์ (ระบุ)', value: 'ค่าวัสดุเวชภัณฑ์และการแพทย์', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุกีฬาและชมรมต่าง ๆ (ระบุ)', value: 'ค่าวัสดุกีฬาและชมรมต่าง ๆ', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุคอมพิวเตอร์และอิเล็กทรอนิกส์ใช้ไป (ระบุ)', value: 'ค่าวัสดุคอมพิวเตอร์และอิเล็กทรอนิกส์ใช้ไป', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุหนังสือ วารสารและตำรา (ระบุ)', value: 'ค่าวัสดุหนังสือ วารสารและตำรา', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุไฟฟ้าและวิทยุ (ระบุ)', value: 'ค่าวัสดุไฟฟ้าและวิทยุ', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุการเกษตร (ระบุ)', value: 'ค่าวัสดุการเกษตร', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุยานพาหนะ (ระบุ)', value: 'ค่าวัสดุยานพาหนะ', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุแต่งกาย (ระบุ)', value: 'ค่าวัสดุแต่งกาย', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าวัสดุวิทยาศาสตร์ (ระบุ)', value: 'ค่าวัสดุวิทยาศาสตร์', hasDescription: true, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] }
          ]
        },
        utilities: {
          selected: null,
          description: '',
          options: [
            { text: 'ค่าไปรษณีย์โทรเลข (ระบุ)', value: 'ค่าไปรษณีย์โทรเลข', hasDescription: false, suffixes: ['ชิ้น', '', 'บาท/ชิ้น'], fillable: [true, true, false, false, true, false, true] },
            { text: 'ค่าสาธารณูปโภคอื่นๆ (ระบุ)', value: 'ค่าสาธารณูปโภคอื่น', hasDescription: true, suffixes: ['', '', ''], fillable: [true, true, true, true, true, true, true] }
          ]
        }
      }
    }
  },
  computed: {
    fundingSummation () {
      return this.value.funding.internal.osda +
        this.value.funding.internal.advance +
        _.sumBy(this.value.funding.external.sponsors, 'amount') +
        _.sumBy(this.value.funding.external.other, 'amount')
    },
    expensesSummation () {
      let summation = new Decimal(0)

      _.each(_.omit(this.value.expenses, '__typename'), group => {
        _.each(group, expense => {
          const result = expense.amountEach * (expense.amountQty > 0 ? expense.amountQty : 1) * (expense.times > 0 ? expense.times : 1) * (expense.qty > 0 ? expense.qty : 1)
          summation = summation.plus(result)
        })
      })

      return summation.toDecimalPlaces(2).toNumber()
    }
  },
  methods: {
    addExpense (group, title, description, suffixes = ['', '', '']) {
      if (title !== null) {
        this.value.expenses[group].push({
          title: title,
          description: description,
          qty: null,
          qtySuffix: suffixes[0],
          times: null,
          timesSuffix: suffixes[1],
          amountEach: null,
          amountQty: null,
          amountQtySuffix: suffixes[2]
        })
      }

      this.$emit('input', this.value)
    },
    deleteExpense (group, index) {
      this.$delete(this.value.expenses[group], index)
    }
  }
}
</script>
